import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const LoanSchema = withDefaults({
  type: 'loan',
  objectExtensions: ['loan'],
  fields: [
    {
      kind: 'attribute',
      name: 'name',
    },
    {
      kind: 'attribute',
      name: 'number',
    },
    {
      kind: 'attribute',
      name: 'deactivatedOn',
    },
    {
      kind: 'attribute',
      name: 'observation',
    },
    {
      kind: 'attribute',
      name: 'observationOverrides',
    },
    {
      kind: 'attribute',
      name: 'isActive',
    },
    {
      kind: 'attribute',
      name: 'originalDisbursementAmount',
    },
    {
      kind: 'attribute',
      name: 'originalDisbursementDate',
    },
    {
      kind: 'attribute',
      name: 'derivedType',
    },
    {
      kind: 'attribute',
      name: 'resolutionSource',
    },
    {
      kind: 'attribute',
      name: 'adminAction',
    },
    {
      kind: 'attribute',
      name: 'loanResolutionId',
    },
    {
      kind: 'belongsTo',
      name: 'account',
      type: 'account',
      options: {
        async: false,
        inverse: 'loans',
      },
    },
  ],
});

export default LoanSchema;
